module.exports = __webpack_public_path__ + "0e8ffc2636c7c7957a89469bae945a10.fbx";